var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBen4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10913",
    "data-name": "Group 10913",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.474,
    height: 74.813,
    viewBox: "0 0 56.474 74.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10854",
    "data-name": "Group 10854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    d: "M54.552,41.755,43.009,35.984a19.412,19.412,0,0,0,7.552-15.39,19.594,19.594,0,1,0-28.5,17.421V49.628c-7.659-1.639-7.2-1.567-8.051-1.567a7.065,7.065,0,0,0-5.023,2.1L4,55.221,22.133,73.354a8.246,8.246,0,0,0,5.878,2.458H50.455a7.084,7.084,0,0,0,7.018-5.949l2.85-16.779A10.66,10.66,0,0,0,54.552,41.755ZM53.305,51.908l-2.85,16.779H28.011a1.315,1.315,0,0,1-.855-.356l-13.11-13.11,15.141,3.171v-37.8a1.781,1.781,0,0,1,3.563,0V41.969h6.27l12.326,6.163A3.587,3.587,0,0,1,53.305,51.908ZM18.5,20.594a12.469,12.469,0,1,1,24.937,0,12.341,12.341,0,0,1-3.562,8.693V20.594a8.906,8.906,0,1,0-17.812,0v8.693A12.341,12.341,0,0,1,18.5,20.594Z",
    transform: "translate(-4 -1)",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBen4);
export default __webpack_public_path__ + "static/media/ben_4.218d5bb003388fb755abc1399ea38342.svg";
export { ForwardRef as ReactComponent };